import React, { useState } from 'react';
import { RiArrowRightSLine } from 'react-icons/ri';
import DeleteChatHistory from '../../DeleteChatHistory';
import DeleteAccountModal from '../../DeleteAccountModal';
import { SecurityTabStyle } from './SecurityTab.styles';

const SecurityTab = () => {
  const [modal, setModal] = useState(null); // 'history' | 'account'

  return (
    <>
      <SecurityTabStyle>
        <div className="info-list">
          <button type="button" className="btn" onClick={() => setModal('history')}>
            <strong className="title">Clear chat history</strong>
            <span className="text">Delete all messages and conversations permanently.</span>
            <RiArrowRightSLine className="icon" />
          </button>
          <button type="button" className="btn" onClick={() => setModal('account')}>
            <strong className="title">Delete my account</strong>
            <span className="text">Permanently delete your AgentCy Labs account.</span>
            <RiArrowRightSLine className="icon" />
          </button>
        </div>
      </SecurityTabStyle>

      {modal === 'history' && <DeleteChatHistory onClose={() => setModal(null)} />}
      {modal === 'account' && <DeleteAccountModal onClose={() => setModal(null)} />}
    </>
  );
};

export default SecurityTab;
